import classNames from 'classnames';
import React from 'react';

import styles from './label.scss';
import { Text } from '@wix/design-system';

interface Props {
  dataHook?: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}

export const Label = ({ children, className, dataHook, ...props }: Props) => {
  return (
    <label
      {...props}
      data-hook={dataHook}
      className={classNames(styles.label, className)}
    >
      <Text size="small" secondary>
        {children}
      </Text>
    </label>
  );
};

export default Label;
